module.exports = __webpack_public_path__ + "static/media/2.ef6e1201.jpg";